import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Utilities_ds_configurations_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { application_name?: string, user_name?: string, name?: string, full_text_search?: string, string_1?: string, string_2?: string, string_3?: string, $top?: number, $skip?: number }): Promise<{ result?: { configuration_id?: string, application_name?: string, user_name?: string, name?: string, value?: string, notes?: string, string_1?: string, string_2?: string, string_3?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, date_number?: number }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/Utilities/datasources/ds_configurations_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { application_name?: string, user_name?: string, name?: string, full_text_search?: string, string_1?: string, string_2?: string, string_3?: string, $keys: string[] }): Promise<{ result?: { configuration_id?: string, application_name?: string, user_name?: string, name?: string, value?: string, notes?: string, string_1?: string, string_2?: string, string_3?: string, created_by?: string, created_on?: string, modified_by?: string, modified_on?: string, date_number?: number }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Utilities/datasources/ds_configurations_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      application_name?: string, user_name?: string, name?: string, full_text_search?: string, string_1?: string, string_2?: string, string_3?: string    }) {
      return false;
    }
}
